import { isValidElement as s } from "react";
import { ChevronDown24Icon as x } from "@material-bank/mb-icons";
import { icon as l, openIcon as e, root as a } from "./styles.js";
import "theme-ui";
import "@theme-ui/css";
import "../../lib/css/match-media-context.js";
import { cloneElementWithCss as f } from "../../lib/css/utils.js";
import { jsx as i } from "theme-ui/jsx-runtime";
import { CenteredBox as d } from "../CenteredBox/CenteredBox.js";
const v = (o) => {
  const {
    open: m,
    openSelector: r,
    icon: n,
    iconSx: p,
    ...c
  } = o, t = {
    ...l,
    ...m && e,
    ...r && {
      [r]: e
    },
    ...p
  };
  return /* @__PURE__ */ i(d, {
    as: "span",
    "aria-hidden": !0,
    ...c,
    sx: {
      ...a,
      ...o.sx
    },
    children: s(n) ? f(n, {
      sx: t
    }) : /* @__PURE__ */ i(x, {
      sx: t
    })
  });
};
export {
  v as CollapseArrow
};
